import cx from 'classnames';
import React from 'react';
import * as styles from './OMTooltip.scss';
import * as mobileStyles from './OMTooltipMobile.scss';

const OMTooltip = properties => (
  <div
    className={cx(styles.tooltip, styles[properties.className], mobileStyles[properties.className], {
      [styles.rtlPosition]: properties.locale === 'he'
    })}
  >
    { !properties.hideCloseButton ? (
      <span className={cx('icon icon-close', styles.closeBtn)} onClick={properties.onClose} />
    ) : null }
    {properties.msg}
  </div>
);

export default OMTooltip;
